<template>
  <div :class="['szw-row szw-rounded-lg szw-w-full szw-bg-white szw-h-[110px] szw-animate-pulse', { 'szw-shadow-lg': hasShadow, 'szw-p-1': hasPadding }]">
    <div class="szw-flex szw-flex-col szw-w-full szw-max-w-[768px] szw-h-full szw-mx-auto">
      <!-- competition name -->
      <div :class="['szw-flex szw-justify-center szw-items-center', skeletonClasses.competition.wrapper]" v-if="hasCompetition">
        <span class="szw-font-normal szw-text-text-icon-tertiary szw-bg-section-static szw-w-[200px] szw-rounded-1" :class="skeletonClasses.competition.text"></span>
      </div>

      <!-- score board -->
      <div class="szw-w-full szw-h-full szw-flex szw-items-center szw-gap-[8px] szw-justify-center">
        <!-- Left side (home) -->
        <div class="szw-flex szw-flex-1 szw-gap-[4px]" :class="dynamicTeamLogoPositionClasses('left')">
          <div class="szw-w-[64px] szw-h-[64px] szw-rounded-full szw-bg-section-static" />
          <div :class="['szw-text-center szw-bg-section-static szw-h-4 szw-rounded-1', skeletonClasses.team.title]"></div>
        </div>

        <!-- Middle section (fixed width) -->
        <div class="szw-w-[140px] szw-h-[78px] szw-flex szw-items-center szw-justify-center">
          <div class="szw-uppercase szw-text-center szw-text-text-icon-primary szw-font-semibold">
            <div class="szw-text-xl szw-bg-section-static szw-w-[78px] szw-h-[30px] szw-mb-1 szw-rounded-1"></div>
            <div class="szw-text-lg szw-leading-[22px] szw-bg-section-static szw-w-[78px] szw-h-6 szw-rounded-1"></div>
          </div>
        </div>

        <!-- Right side (away) -->
        <div class="szw-flex szw-flex-1 szw-gap-[4px]" :class="dynamicTeamLogoPositionClasses('right')">
          <div class="szw-w-[64px] szw-h-[64px] szw-rounded-full szw-bg-section-static" />
          <div :class="['szw-text-center szw-bg-section-static szw-h-4 szw-rounded-1', skeletonClasses.team.title]"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

/** @type {{ rightSectionType: '' | 'icon' | 'logo' }} */
const props = defineProps({
  widgetSize: {
    type: Object,
    default: () => {}
  },
  size: {
    type: Number,
    default: () => 640
  },
  hasShadow: {
    type: Boolean,
    default: true
  },
  hasPadding: {
    type: Boolean,
    default: true
  },
  hasCompetition: {
    type: Boolean,
    default: true
  }
})

const dynamicTeamLogoPositionClasses = alignment => {
  if (props.size < 480) {
    return alignment === 'left' ? 'szw-flex-col szw-justify-center szw-items-end' : 'szw-flex-col szw-justify-center szw-items-start'
  } else {
    return alignment === 'left' ? 'szw-flex-row-reverse szw-justify-start szw-items-center' : 'szw-flex-row szw-justify-start szw-items-center'
  }
}

const skeletonClasses = computed(() => {
  let competition = {
    wrapper: 'szw-h-[20px]',
    text: 'szw-h-[18px]'
  }

  let team = {
    title: 'szw-w-[140px]'
  }

  if (props.size < 480) {
    competition = {
      wrapper: 'szw-h-[18px]',
      text: 'szw-h-[16px]'
    }

    team = {
      title: 'szw-w-[64px]'
    }
  } else if (props.size >= 480 && props.size < 640) {
    team = {
      title: 'szw-w-[78px]'
    }
  }

  return {
    competition,
    team
  }
})
</script>
